import { motion } from "motion/react";
import { useInView } from "../../../components/hooks/useInView.jsx";

function FeatureCard({ emoji, title, description }) {
  return (
    <div className="flex flex-col gap-2 items-center text-center">
      <div className="text-4xl">{emoji}</div>
      <h4 className="text-white text-xl">{title}</h4>
      <p className="text-[#99a1af]">{description}</p>
    </div>
  );
}


export function HiFiDesigns() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section ref={ref} className="py-20 max-w-7xl mx-auto px-6">
      <div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl mb-8">Low-Fidelity Designs</h2>
          <div className="h-1 w-20 bg-[#fd5b38] mx-auto mb-8" />
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
            Polished UI with attention to detail, light reflections, and smooth
            transitions
          </p>
        </motion.div>

        <div className="max-w-7xl mx-auto my-16 bg-gradient-to-b from-[#1a1a1a] to-[#000000] relative rounded-[24px] size-full overflow-hidden p-6 md:p-12">
          <img
            src="/assets/imgs/case-studies/fitness_tracker_2.png"
            alt="Background Grid"
            className=""
          />
        </div>
      </div>
      <div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl mb-8">High-Fidelity Designs</h2>
          <div className="h-1 w-20 bg-[#fd5b38] mx-auto mb-8" />
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
            Polished UI with attention to detail, light reflections, and smooth
            transitions
          </p>
        </motion.div>

        <div className="max-w-7xl mx-auto my-16 bg-gradient-to-b from-[#1a1a1a] to-[#000000] relative rounded-[24px] size-full overflow-hidden p-6 md:p-12">
          <img
            src="/assets/imgs/case-studies/fitness_tracker_3.png"
            alt="Background Grid"
            className=""
          />
        </div>
      </div>
      <div
        className="bg-gradient-to-r from-[rgba(0,0,0,0)] relative rounded-[24px] size-full to-[rgba(0,0,0,0)] via-50% via-[rgba(253,91,56,0.2)]"
        data-name="Container"
      >
        <div
          aria-hidden="true"
          className="absolute border-[0.8px] border-[rgba(253,91,56,0.3)] border-solid inset-0 pointer-events-none rounded-[24px]"
        />
        <div className="size-full">
          <div className="flex flex-col gap-8 items-center p-6 md:p-10 lg:p-12 relative size-full">
            <h3 className="text-[#fd5b38] text-2xl md:text-3xl lg:text-4xl text-center">
              Design System Highlights
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-6 lg:gap-8 w-full max-w-5xl">
              <FeatureCard
                emoji="✨"
                title="Light Reflections"
                description="Subtle gradients and glows create depth"
              />
              <FeatureCard
                emoji="🎨"
                title="Blur Layers"
                description="Glassmorphism for modern aesthetics"
              />
              <FeatureCard
                emoji="⚡"
                title="Smooth Transitions"
                description="Every interaction feels fluid and natural"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
